import * as elements from "./elements";
import palletes from "./palletes";

export default {
  ...elements,
  palletes,
} as const;
